var _rect, _text, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholderLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_Web:_Businesspartner_logo",
    "data-name": "Logo Web: Businesspartner logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 206,
    height: 44,
    viewBox: "0 0 206 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_367",
    "data-name": "Rectangle 367",
    width: 205,
    height: 42,
    transform: "translate(0 1)",
    fill: "none"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Businesspartner_Logo",
    "data-name": "Businesspartner Logo",
    transform: "translate(63 19)",
    fill: "#061133",
    fontSize: 18,
    fontFamily: "OpenSans-SemiBold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Businesspartner"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "OpenSans-BoldItalic, Open Sans",
    fontWeight: 700,
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 20
  }, "Logo")))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    transform: "translate(0 1)",
    fill: "#f5f5f5",
    stroke: "#061133",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 42,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 54,
    height: 40,
    rx: 6,
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderLogo);
export default __webpack_public_path__ + "static/media/placeholder-logo.f8e93e65be125c8e68f4c9571ee9cfde.svg";
export { ForwardRef as ReactComponent };